import {DeleteConfirmModalProps} from 'models/CreatePromotion'
import {useTranslation} from 'react-i18next'

const DeleteConfirmModal = ({
 title,
 description,
 onConfirm,
 onCancel,
}: DeleteConfirmModalProps) => {
 const {t} = useTranslation()
 return (
  <div className='fixed inset-0 z-50 flex items-center justify-center bg-black/40'>
   <div className='relative w-[460px] rounded-2xl bg-white p-6 shadow-lg'>
    <button
     onClick={onCancel}
     className='absolute right-4 top-4 flex h-8 w-8 items-center justify-center rounded-full hover:bg-gray-100'
    >
     ✕
    </button>

    <h2 className='text-lg font-semibold text-gray-900'>
     {title}
    </h2>

    {description && (
     <p className='mt-2 text-sm text-gray-600'>
      {description}
     </p>
    )}

    <div className='mt-6 flex gap-4'>
     <button
      onClick={onConfirm}
      className='flex-1 rounded-lg bg-[#2E7D32] py-2.5 text-sm font-medium text-white hover:bg-[#256628]'
     >
      {t('confirmation.yes')}
     </button>

     <button
      onClick={onCancel}
      className='flex-1 rounded-lg bg-[#C63C3C] py-2.5 text-sm font-medium text-white hover:bg-[#B03030]'
     >
      {t('confirmation.no')}
     </button>
    </div>
   </div>
  </div>
 )
}

export default DeleteConfirmModal
